<template>
  <!--<div>-->
  <div class="partnersMain">
    <!--banner+导航-->
    <div class="bannerBox" >
      <img  ref="homeBanner" src="../../../assets/img/onlineBanner.jpg"/>
      <div class="topTextBox">
        <!--导航-->
        <top-nav></top-nav>
        <!--<top-nav :nav-index1="6"></top-nav>-->
      </div>
    </div>
    <div class="servicesContent">
      <div class="contentW">
        <div class="services01"  id="m1">
          <div style="width: 100%;margin: auto;min-width: 62.5rem;" >
            <div class="leftBox animated" :class="animates.mm1 ? 'fadeInUp' : 'hideBox'"><img src="../../../assets/icon/servicesImg1.png"/><div class="box"></div></div>
            <div class="rightBox animated" :class="animates.mm1 ? 'fadeInUp' : 'hideBox'">
              <div class="titles">微信朋友圈广告</div>
              <div class="contents">让产品、内容、服务，这些身边的事物， 恰好出现</div>
              <div class="btn" @click="navClick('applyCn')">联系我们</div>
            </div>
          </div>
        </div>

        <div class="services02" id="m2">
          <div style="width: 100%;margin: auto;min-width: 62.5rem;">
            <div class="rightBox animated" :class="animates.mm2 ? 'fadeInUp' : 'hideBox'">
              <div class="titles">微信支付成功界面广告</div>
              <div class="contents">每日超过10000次曝光，帮助你吸引优质的潜在客户。 </div>
              <div class="btn" @click="navClick('applyCn')">联系我们</div>
            </div>
            <div class="leftBox animated" :class="animates.mm2 ? 'fadeInUp' : 'hideBox'"><img src="../../../assets/icon/servicesImg2.png"/></div>
          </div>
        </div>
      </div>

      <div class="services03">
        <div class="contentW" id="m3">
          <div class="titles animated" :class="animates.mm3 ? 'fadeInUp' : 'hideBox'">多平台营销</div>
          <ul class="contentUl animated" :class="animates.mm3 ? 'fadeInUp' : 'hideBox'">
            <li>
              <div class="iconBox"><img src="../../../assets/icon/servicesIcon1.png"/></div>
              <div class="textBox">
                <div class="titleText">支付宝境外红包</div>
                <div class="contentText">支付宝境外红包活动，活动期间内每人每月可领3次红包，在门店付款时自动立减红包金额，最高可得2888元。红包的领取和使用都没有门槛，在门店付款时自动立减红包金额。</div>
              </div>
            </li>
            <li>
              <div class="iconBox"><img src="../../../assets/icon/servicesIcon2.png"/></div>
              <div class="textBox">
                <div class="titleText">微信支付红包</div>
                <div class="contentText">微信红包可以让消费者在消费后摇一摇，已获得代金券或者直接免单的机会。红包的领取和使用都没有门槛。</div>
              </div>
            </li>
            <li>
              <div class="iconBox"><img src="../../../assets/icon/servicesIcon3.png"/></div>
              <div class="textBox">
                <div class="titleText">支付宝/微信支付节日活动</div>
                <div class="contentText">支付宝于微信支付在节假日期间都提供推广活动，用以帮助商家进行推广或提供优惠代金券，只需消费者扫码即可领取。</div>
              </div>
            </li>
          </ul>
        </div>
        <div class="contentW" id="m4">
          <div class="titles animated" :class="animates.mm4 ? 'fadeInUp' : 'hideBox'">微信支付推广活动</div>
          <ul class="contentUl animated" :class="animates.mm4 ? 'fadeInUp' : 'hideBox'">
            <li>
              <div class="iconBox"><img src="../../../assets/icon/servicesIcon4.png"/></div>
              <div class="textBox">
                <div class="titleText">微信朋友圈广告</div>
                <div class="contentText">丰富的广告形态，满足日益精细的投放需求。将你的品牌推广到目前微信澳洲拥有的2,900,000活跃用户手机中。</div>
              </div>
            </li>
            <li>
              <div class="iconBox"><img src="../../../assets/icon/servicesIcon5.png"/></div>
              <div class="textBox">
                <div class="titleText">微信支付成功界面广告</div>
                <div class="contentText">在我们SuperiorPay的微信支付成功界面做推广广告，以获得每日10000+的曝光量。</div>
              </div>
            </li>
            <li>
              <div class="iconBox"><img src="../../../assets/icon/servicesIcon6.png"/></div>
              <div class="textBox">
                <div class="titleText">微信“境外游礼包”小程序</div>
                <div class="contentText">这是微信支付向海外市场发布的小程序，其中包含商家和微信支付提供的优惠信息。</div>
              </div>
            </li>
          </ul>
        </div>
        <div class="contentW" id="m5">
          <div class="titles animated" :class="animates.mm5 ? 'fadeInUp' : 'hideBox'">支付宝推广活动</div>
          <ul class="contentUl animated" :class="animates.mm5 ? 'fadeInUp' : 'hideBox'">
            <li>
              <div class="iconBox"><img src="../../../assets/icon/servicesIcon7.png"/></div>
              <div class="textBox">
                <div class="titleText">支付宝“发现”推广界面</div>
                <div class="contentText">在支付宝发现平台上的商家列表可以详细描述商店位置，客户评论以及优惠活动，并且会在支付宝App中进行推送。</div>
              </div>
            </li>
            <li>
              <div class="iconBox"><img src="../../../assets/icon/servicesIcon8.png"/></div>
              <div class="textBox">
                <div class="titleText">支付宝城市卡</div>
                <div class="contentText">商户的优惠活动会被列于支付宝城市卡上，海外游客可以在页面上发现优惠活动并直接参与。</div>
              </div>
            </li>
            <li>
              <div class="iconBox"><img src="../../../assets/icon/servicesIcon9.png"/></div>
              <div class="textBox">
                <div class="titleText">支付宝周活动</div>
                <div class="contentText">支付宝周活动中，支付宝会为商户提供显眼的推送版位，并且提供大量优惠活动，例如：1元换购20元，等。</div>
              </div>
            </li>
          </ul>
        </div>
      </div>

    </div>

    <!--底部-->
    <Footer></Footer>

  </div>
  <!--</div>-->
</template>

<script>
  import topNav from './navCn'
  import Footer from "@/components/Footer"
  let timer = null; //定义初始值
  export default {
    name: "servicesCn",
    components:{topNav,Footer},
    props:{
      step:{   //此数据是控制动画快慢的
        type:Number,
        default:50
      }
    },
    data() {
      return {
        animates:{
          mm1:false,
          mm2:false,
          mm3:false,
          mm4:false,
          mm5:false,
        },
      }
    },
    destroyed(){
      window.removeEventListener('scroll', this.handleScroll);//监听页面滚动事件
    },
    mounted () {
      document.documentElement.scrollTop=0;

      this.animates.mm1 = true;
      if(window.innerWidth>1200){
        window.addEventListener('scroll', this.handleScroll)
      }else {
        this.animates.mm2 = true;
        this.animates.mm3 = true;
        this.animates.mm4 = true;
        this.animates.mm5 = true;
      }
    },
    methods:{
      //  点击导航
      navClick(url){
        this.$router.push({
          name: url
        });
      },


      handleScroll () {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

        // var offsetTop1 = document.querySelector('#m1').offsetTop;
        var offsetTop2 = document.querySelector('#m2').offsetTop;
        var offsetTop3 = document.querySelector('#m3').offsetTop;
        var offsetTop4 = document.querySelector('#m4').offsetTop;
        var offsetTop5 = document.querySelector('#m5').offsetTop;



        if (scrollTop > offsetTop2-200) {
          this.animates.mm2 = true
        } else {
          this.animates.mm2 = false
        }
        if (scrollTop > offsetTop3-1000) {
          this.animates.mm3 = true
        } else {
          this.animates.mm3 = false
        }
        if (scrollTop > offsetTop4-1000) {
          this.animates.mm4 = true
        } else {
          this.animates.mm4 = false
        }
        if (scrollTop > offsetTop5-1000) {
          this.animates.mm5 = true
        } else {
          this.animates.mm5 = false
        }
      },

      //置顶
      toTop(){ // 动画

        timer = setInterval(function () {
          let osTop = document.documentElement.scrollTop || document.body.scrollTop;
          let ispeed = Math.floor(-osTop / 5);
          document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
          // this.isTop = true
          if (osTop === 0) {
            clearInterval(timer)
          }
        },30)

      },
    }
  }
</script>

<style scoped>



  .partnersMain{width: 100%;height: auto;}
  .partnersMain .bannerBox{width: 100%;height: auto;position: relative;}
  .partnersMain .bannerBox>img{width: 100%;}
  .partnersMain .bannerBox .topTextBox{width: 100%;height: 100%;position: absolute;top: 0;left: 0;}


  /*内容部分*/
  .servicesContent{width: 100%;height: auto;padding: 2rem 0 0rem 0;background-color: #fff;}

  /*模块1*/
  .services01{width: 100%;height: auto;overflow: hidden;border-bottom: 1px solid #979797;padding-top: 5rem;}
  .services01 .leftBox{width: 50%;height: 100%;float: left;text-align: left;position: relative;}
  .services01 .leftBox>img{width: 360px;padding-left: 25%;}
  .services01 .leftBox>.box{width: 100%;height: 50px;position: absolute;bottom: 0;
    background: -webkit-linear-gradient(rgba(255,255,255,0), rgba(255,255,255,0.8)); /* Safari 5.1 - 6.0 */
    background: -o-linear-gradient(rgba(255,255,255,0), rgba(255,255,255,0.8)); /* Opera 11.1 - 12.0 */
    background: -moz-linear-gradient(rgba(255,255,255,0), rgba(255,255,255,0.8)); /* Firefox 3.6 - 15 */
    background: linear-gradient(rgba(255,255,255,0), rgba(255,255,255,0.8)); /* 标准的语法 */
  }
  .services01 .rightBox{width: calc(50% - 30px);height: 100%;float: right;}
  .services01 .rightBox .titles{font-size: 2.25rem;font-family: PingFangRegular;color: #4a4a4a;line-height: 3rem;margin-top: 5rem;}
  .services01 .rightBox .contents{font-size: 1.25rem;font-family: PingFangRegular;color: #4a4a4a;line-height: 1.8rem;margin-top: 2rem;}
  .services01 .rightBox .btn{font-size: 0.97rem;width: 8rem; font-family: PingFangMedium;text-align: center; color: #4a4a4a;height: 2.7rem; line-height: 2.7rem;margin-top: 2rem;border: 1px solid #4a4a4a;border-radius: 4px;cursor: pointer;}


  /*模块2*/
  .services02{width: 100%;height: auto;overflow: hidden;padding-top: 53px;}
  .services02 .leftBox{width: calc(50% - 30px);height: 100%;float: right;text-align: center;position: relative; }
  .services02 .leftBox>img{width: 468px;}
  .services02 .rightBox{width: calc(50% + 30px);height: 100%;float: left;}
  .services02 .rightBox .titles{font-size: 2.25rem;font-family: PingFangMedium;color: #4a4a4a;line-height: 3rem;margin-top: 5rem;margin-left: 25%;}
  .services02 .rightBox .contents{font-size: 1.25rem;font-family: PingFangMedium;color: #4a4a4a;line-height: 1.8rem;margin-top: 2rem;margin-left: 25%;}
  .services02 .rightBox .btn{font-size: 0.97rem;width: 8rem; font-family: PingFangMedium;text-align: center; color: #4a4a4a;height: 2.7rem;margin-left: 25%; line-height: 2.7rem;margin-top: 2rem;border: 1px solid #4a4a4a;border-radius: 4px;cursor: pointer;}

  /*模块3*/
  .services03{width: 100%;height:auto;padding:5rem 0; background-color: #f6f6f6;}
  .services03 .titles{padding-top: 2rem;width: 100%;height: 5rem;line-height: 5rem;font-family: PingFangMedium;font-size: 1.5rem;text-align: center;border-bottom: 1px solid #979797;}
  .services03 .contentUl{width: calc(100% - 4rem);height: 13.75rem;overflow: hidden;padding:3rem 2rem;}
  .services03 .contentUl>li{float: left;width: 33.33%;height: 100%;}
  .services03 .contentUl>li .iconBox{width: 6rem;height: 100%;float: left;text-align: center; }
  .services03 .contentUl>li .textBox{width: calc(90% - 6rem);min-width: 17.5rem; float: left;height: 100%;}
  .services03 .contentUl>li .textBox .titleText{width: 100%;height: auto;font-family: PingFangRegular;font-weight: 600; font-size: 1rem;color: #4a4a4a;line-height: 3rem;}
  .services03 .contentUl>li .textBox .contentText{width: 100%;height: auto;font-family: PingFangMedium;font-size: 0.875rem;color: #4a4a4a;line-height: 1.8rem;}

  .hideBox{display: none;}
.uline{
  /* height:1px; */
  margin-top: 10px;
  border-bottom: #4a4a4a 1px solid;
}
.privacy {
  /* border-top: #4a4a4a 1px solid; */
  margin-top: 10px;
}
</style>
